module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2_m_jp.6e9a8d912877d546266795acd7a244ae.png";